<template>
  <div class="site_list_box padding-md text-white">
    <div v-if="$route.path.lastIndexOf('/') === 0">
      <!-- 搜索框 -->
      <div class="box-card">
        <div class="text item">
          <el-form inline class="padding-top margin-sm-bottom">
            <el-form-item :label="$t('siteList.siteId')">
              <el-input
                :placeholder="$t('siteList.inputSiteId')"
                v-model="searchForm.siteId"
                style="width: 250px"
                clearable
              />
            </el-form-item>
            <el-form-item :label="$t('siteList.siteName')">
              <el-input
                :placeholder="$t('siteList.inputSiteName')"
                v-model="searchForm.name"
                style="width: 250px"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-button
                class="btn-purple"
                icon="el-icon-search"
                :disabled="role >= 1 ? true : false"
                @click="querySite()"
                v-preventReClick
                >{{ $t("siteList.checkButton") }}</el-button
              >
              <el-button
                v-auth="btnAuth.add"
                class="btn-green"
                icon="el-icon-plus"
                @click="onAdd(1)"
                >{{ $t("deviceList.addEquipment") }}</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 站点数据信息展示表格 -->
      <div class="table-box">
        <el-table
          :data="siteData"
          style="width: 100%"
          :cell-style="{ 'text-align': 'center' }"
          :header-cell-style="{ 'text-align': 'center' }"
          :row-class-name="tableRowClassName"
          :row-style="{ height: '60px' }"
        >
          <el-table-column label="产品名称" prop="name"> </el-table-column>
          <el-table-column label="产品类型" prop="istallWay"> </el-table-column>
          <el-table-column label="电池类型" prop="online">
            <template slot-scope="scope">
              {{ batType[scope.row.batteryType] }}
            </template>
          </el-table-column>
          <el-table-column label="功率" prop="power"> </el-table-column>
          <el-table-column label="容量" prop="capacity"> </el-table-column>
          <el-table-column label="价格(w/h)" prop="prices"> </el-table-column>
          <el-table-column :label="$t('deviceList.operation')" min-width="100">
            <!-- 操作按钮 -->
            <template v-slot="{ row }">
              <div class="flex items-middle space-around">
                <el-button
                  class="text-red"
                  type="text"
                  @click="onAdd(2, row)"
                  v-auth="btnAuth.edit"
                  size="mini"
                >
                  <icon type="icon-bianji" color="#234659" size="25"></icon
                ></el-button>
                <el-button
                  class="text-red"
                  type="text"
                  @click="onDelete(row)"
                  v-auth="btnAuth.delete"
                  size="mini"
                >
                  <icon type="icon-shanchu1" color="#234659" size="25"></icon
                ></el-button>
                <!-- <el-button
                  class="text-red"
                  type="text"
                  @click="onDelete(row)"
                  icon="el-icon-delete"
                  v-auth="btnAuth.delete"
                  size="mini"
                  >{{ $t("deviceList.deleteDevice") }}</el-button
                >
                <el-button
                  class="text-blue"
                  type="text"
                  @click="onAdd(2, row)"
                  icon="el-icon-edit"
                  v-auth="btnAuth.edit"
                  size="mini"
                  >{{ $t("deviceList.editInfo") }}</el-button
                > -->
                <!-- <div>
                  <i class="el-icon-view"></i>
                  <el-button
                    class="text-blue"
                    type="text"
                    @click="onAdd(3, row)"
                    >查看</el-button
                  >
                </div> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 翻页 -->
        <div class="block" style="margin-top: 15px">
          <pagination
            :total="countNum"
            v-on:getCurrent="changeCurrent"
            v-on:getPageSize="changePage"
          ></pagination>
        </div>
      </div>
    </div>
    <produce-edit ref="produceUpdate" @refresh="getSite"></produce-edit>
    <!-- <router-view v-else></router-view> -->
  </div>
</template>

<script>
import pagination from "../../components/pagination.vue";
import { deviceModelQuery, deviceModelDelete } from "../../api/siteList";
import i18n from "@/lang";
import ProduceEdit from "./components/produceEdit.vue";
export default {
  components: { pagination, ProduceEdit },
  data() {
    return {
      batType: ["", "梯次电池", "新电池"],
      searchForm: {
        siteId: "",
        name: "",
      },
      siteData: [],
      searchRules: {
        siteId: [
          { required: false, message: "请输入站点ID", trigger: "blur" },
          {
            pattern: /^[a-zA-Z][a-zA-Z0-9_]*$/,
            message: "用户ID以字母开头，且只能包含英文字母、数字、下划线",
          },
        ],
      },
      object: {
        pageNumber: 1,
        pageSize: 10,
        para: {},
      },
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页的数据条数
      role: 0, //角色
      countNum: 0,
      btnAuth: {
        add: "siteAdd",
        delete: "siteDelete",
        edit: "siteEdit",
        detail: "siteDetail",
        editc: "siteCustomerEdit",
        issued: "issued",
      },
    };
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.getSite();
    },
    getSite() {
      // console.log(obj);
      deviceModelQuery(this.object)
        .then((res) => {
          console.log(res.data.data);
          this.countNum = res.data.data.totalElements;
          this.siteData = res.data.data.content;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    querySite() {
      let obj = {
        pageNumber: this.object.pageNumber,
        pageSize: this.object.pageSize,
        para: {
          siteId: this.searchForm.siteId,
          name: this.searchForm.name,
        },
      };
      deviceModelQuery(obj).then((res) => {
        if (res.data.data.content.length == 0) {
          this.$message({
            type: "warning",
            message: "暂无结果",
          });
        } else {
          this.countNum = res.data.data.totalElements;
          this.siteData = res.data.data.content;
        }
      });
    },
    onAdd(type, row = {}) {
      this.$refs.produceUpdate.open(type, row);
    },
    onDelete(row) {
      console.log(row.id);
      this.$confirm(
        i18n.t("prompt.deletePromptInfo"),
        i18n.t("prompt.promptInfo"),
        {
          confirmButtonText: i18n.t("prompt.confirm"),
          cancelButtonText: i18n.t("prompt.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          deviceModelDelete({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: i18n.t("prompt.operateSuccessfully"),
              });
              this.getSite();
            } else {
              this.$message({
                type: "error",
                message: i18n.t("prompt.operationFailure") + res.data.message,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: i18n.t("prompt.OperationCancelled"),
          });
        });
    },
    changeCurrent(data) {
      this.object.pageNumber = data;
      this.currentPage = data;
      console.log(this.object);
      this.getSite();
    },
    changePage(data) {
      this.object.pageSize = data;
      this.pageSize = data;
      console.log(this.object);
      this.getSite();
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "";
      } else {
        return "warning-row";
      }
    },
  },
  filters: {
    num: (val, fix = 2) => {
      if (val < 0) {
        val = parseFloat(val);
        val = val.toFixed(fix); // 保留小数2位
        val = Math.abs(val);
        val = "" + val; // 转换成字符串
        console.log("llllll", val);
        var int = val.slice(0, fix * -1 - 1); // 拿到整数
        var ext = val.slice(fix * -1 - 1); // 获取到小数
        int = int.split("").reverse().join(""); // 翻转整数
        var temp = ""; // 临时变量
        for (var i = 0; i < int.length; i++) {
          temp += int[i];
          if ((i + 1) % 3 == 0 && i != int.length - 1) {
            temp += ","; // 每隔三个数字拼接一个逗号
          }
        }
        temp = temp.split("").reverse().join(""); // 加完逗号之后翻转
        temp = temp + ext; // 整数小数拼接
        return "-" + temp; // 返回
      } else if (val != "-" && val != "" && val != null && val > 0) {
        val = parseFloat(val);
        val = val.toFixed(fix); // 保留小数2位
        val = "" + val; // 转换成字符串
        int = val.slice(0, fix * -1 - 1); // 拿到整数
        ext = val.slice(fix * -1 - 1); // 获取到小数
        int = int.split("").reverse().join(""); // 翻转整数
        temp = ""; // 临时变量
        for (i = 0; i < int.length; i++) {
          temp += int[i];
          if ((i + 1) % 3 == 0 && i != int.length - 1) {
            temp += ","; // 每隔三个数字拼接一个逗号
          }
        }
        temp = temp.split("").reverse().join(""); // 加完逗号之后翻转
        temp = temp + ext; // 整数小数拼接
        return temp; // 返回
      } else if (val == 0 || val == "0") {
        return val;
      } else {
        return "-";
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.site_list_box{
    width: 100%;
    box-sizing: border-box;
    height: calc(100vh - 130px);
    overflow: auto;
}
.table-box{
  padding: 20px;
    // background: linear-gradient(45deg, #35478a, #162257);
    background: #102135
    border-radius: 10px;
}
/deep/.el-table, .el-table tr, .el-table td, .el-table th {
    background-color: transparent!important;
}
</style>
